import { TeamService } from "./../../services/settings-service/team/team.service";
import { ReservationService } from "./../../services/reservation-service/reservation.service";
import { FormBuilder, FormGroup } from "@angular/forms";
import { SlimLoadingBarService } from "ng2-slim-loading-bar";
import { ErrorHandlerService } from "./../../services/shared/error-handler.service";
import { UserServiceService } from "./../../services/user-service/user-service.service";
import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";

import swal from "sweetalert2";
import { PaginationComponent } from "../../layout/pagination/pagination.component";

@Component({
  selector: "app-wallet",
  templateUrl: "./wallet.component.html",
  styleUrls: ["./wallet.component.css"],
})
export class WalletComponent implements OnInit {
  selectedWallet: any = {};
  filter_expand = false;
  filterForm: FormGroup;
  wallet: any;
  last_page_url: any;
  users: any;
  searchedUsers: any;
  teams: any;
  projects: any;
  userData: any = JSON.parse(window.localStorage.getItem("userProfile")) || {};
  current_balance: any;
  has_filter_data: boolean = false;
  current_commission: any;
  current_wallet_id: any;
  excel: any;
  active_tab = "all";
  commissioned_for_search: string | null = null;
  check_all: boolean = false;
  page = 1;
  page_length = 15;

  constructor(
    private userService: UserServiceService,
    private errorHandlerService: ErrorHandlerService,
    private formBuilder: FormBuilder,
    private slimLoadingService: SlimLoadingBarService,
    private reservationService: ReservationService,
    private teamService: TeamService
  ) {}

  ngOnInit() {
    if (this.userData.role !== "Property Consultant") {
      this.getUsers();
    }
    this.getProjects();
    if (this.userData.role == "Admin" || this.userData.role === "CFO") {
      this.getTeams();
    }
    this.setActiveTab("all");
    this.getWallet();
  }

  setActiveTab(tab) {
    this.active_tab = tab;
    let userId = "";
    switch (tab) {
      case "me": {
        userId = this.userData.id;
      }
    }
    if (this.userData.role == "Admin" || this.userData.role === "CFO") {
      this.adminCreateForm(userId);
    } else {
      this.userCreateFilterForm(userId);
    }
    this.getWallet();
    this.page = 1;
    this.page_length = 15;
  }

  changePageLength(page_length) {
    this.page_length = page_length;
    this.page = 1;
    this.getWallet();
  }

  adminCreateForm(userId?) {
    this.filterForm = this.formBuilder.group({
      from: [""],
      to: [""],
      team_id: [null],
      project_ids: [[]],
      commissioned_for: [userId || null],
      from_collect: [""],
      to_collect: [""],
      reservation_id: [""],
      unit_serial: [""],
      is_collect: [""],
      sales_type: [null],
      type: [null],
      is_approve: [null],
    });
  }

  userCreateFilterForm(userId) {
    this.filterForm = this.formBuilder.group({
      from: [""],
      to: [""],
      project_ids: [[]],
      commissioned_for: [userId || ""],
      from_collect: [""],
      to_collect: [""],
      reservation_id: [""],
      unit_serial: [""],
      is_collect: [""],
      sales_type: [null],
      type: [null],
      is_approve: [null],
    });
  }

  getWallet() {
    let payload = this.filterForm.value;
    payload.page = this.page;
    payload.page_length = this.page_length;
    this.slimLoadingService.start();
    this.userService.filterWallet(payload).subscribe(
      (res: any) => {
        this.wallet = res;
        this.last_page_url = res.wallets.last_page_url;
        this.slimLoadingService.complete();
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingService.complete();
      }
    );
  }

  deleteCommission(id) {
    swal({
      title: "Are you sure?",
      text: "You will delete this commission!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it",
    }).then((result) => {
      if (result.value) {
        this.slimLoadingService.start();
        this.userService.deleteCommission(id).subscribe(
          (res: any) => {
            this.getWallet();
            swal("success", "Deleted commission successfully!", "success");
          },
          (err) => {
            this.errorHandlerService.handleErorr(err);
            this.slimLoadingService.complete();
          }
        );
      }
    })
  }

  getUsers() {
    this.slimLoadingService.start();
    this.userService.getUsersWallets().subscribe(
      (res: any) => {
        this.users = res;
        this.searchedUsers = res;
      },
      (err) => this.errorHandlerService.handleErorr(err)
    );
  }

  getProjects() {
    this.slimLoadingService.start();
    this.reservationService.getProjects({ is_select_form: true }).subscribe(
      (data) => {
        this.projects = data;
        this.slimLoadingService.complete();
      },
      (err) => {
        this.slimLoadingService.complete();
        this.errorHandlerService.handleErorr(err);
      }
    );
  }

  getTeams() {
    this.slimLoadingService.start();
    this.teamService.getTeams().subscribe(
      (data) => {
        this.teams = data.data;
      },
      (err) => this.errorHandlerService.handleErorr(err),
      () => this.slimLoadingService.complete()
    );
  }

  pageChange(event) {
    this.page = event;
    this.getWallet();
  }

  resetFilter() {
    this.setActiveTab(this.active_tab);
  }

  payWallet(id) {
    this.slimLoadingService.start();
    this.userService.payWallet(id).subscribe(
      (res: any) => {
        this.slimLoadingService.complete();
        this.getWallet();
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingService.complete();
      }
    );
  }

  exportWallet() {
    let data = this.filterForm.value;
    data.excel = 1;
    this.userService.exportWallet(data).subscribe(
      (res: any) => {
        window.open(res.url);
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
      }
    );
  }

  approveWallet(id) {
    swal({
      title: "Are you sure?",
      text: "You will approve this wallet!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, approve it!",
      cancelButtonText: "No, keep it",
    }).then((result) => {
      if (result.value) {
        const payload = {
          ids: [id],
        };
        this.slimLoadingService.start();
        this.userService.approveWallet(payload).subscribe(
          (res: any) => {
            swal("Success", "approved successfully", "success");
            this.slimLoadingService.complete();
            this.getWallet();
          },
          (err) => {
            this.errorHandlerService.handleErorr(err);
            this.slimLoadingService.complete();
          }
        );
      } else if (result.dismiss) {
        swal("Cancelled", "", "warning");
      }
    });
  }

  changeCommissionValue(modal) {
    const payload = {
      wallet_id: this.selectedWallet.id,
      commission: this.selectedWallet.commission,
    };
    this.slimLoadingService.start();
    this.userService.editCommission(payload).subscribe(
      (res: any) => {
        this.closeModal(modal);
        this.slimLoadingService.complete();
        this.getWallet();
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingService.complete();
      }
    );
  }

  onCheckAllToggle(event) {
    if (this.wallet.wallets) {
      this.check_all = event;
      this.wallet.wallets.data.forEach((e) => {
        if (this.check_all) {
          e.checked = true;
        } else {
          e.checked = false;
        }
      });
    }
  }

  approveWalletSelected() {
    let selectedWallets = this.wallet.wallets.data.filter((list) => {
      if (list.checked == true) return true;
    });
    if (!selectedWallets.length) {
      swal("warning", "There is no selected Cheques");
      return;
    }
    swal({
      title: "Are you sure?",
      text: "You will approve!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, approve it!",
      cancelButtonText: "No, keep it",
    })
      .then((result) => {
        if (result.value) {
          const payload = {
            ids: selectedWallets.map((doc) => doc.id),
          };
          this.slimLoadingService.start();
          this.userService.approveWallet(payload).subscribe(
            (res: any) => {
              swal("Success", "approved successfully", "success");
              this.slimLoadingService.complete();
              this.setActiveTab(this.active_tab);
            },
            (err) => {
              this.errorHandlerService.handleErorr(err);
              this.slimLoadingService.complete();
            }
          );
        } else if (result.dismiss) {
          swal("Cancelled", "", "error");
        }
      })
      .catch((err) => {
        swal("Cancelled", "", "error");
      });
  }

  closeModal(modal: any) {
    modal.close();
  }

  usersSearch(search) {
    this.searchedUsers = this.users.filter((user) => {
      return user.name.toLowerCase().includes(search.toLowerCase());
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/reports/wallet/wallet.component.ts